import { useCallback, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '@/context/auth-context'
import { kFeatureFlags, kGetFeatureFlagStatus } from '@/constants/constants-feature-flags'

export function useCollaborationUpsell() {
  const navigate = useNavigate()
  const { userAccountData } = useContext(AuthContext)
  const collaborationEnabled = kGetFeatureFlagStatus(kFeatureFlags.COLLABORATION)
  const isOrgAccount = !!userAccountData?.isOrgAccount

  const handleUpsellClick = useCallback(() => navigate('/dashboard/account'), [navigate])

  return {
    showUpsell: collaborationEnabled && !isOrgAccount,
    collaborationEnabled,
    handleUpsellClick,
  }
}
